// extracted by mini-css-extract-plugin
module.exports = {"stories":"stories_stories___8tqG","mobile_stories":"stories_mobile_stories__31yE8"};